
import { Component, Prop, Vue, Watch} from "vue-property-decorator";
import timeRangeForNew from "@/helpers/cardInfoHelperFunctions/timeRangeForNew";

import GET_GROUPS from "@/apollo/dashboard/GetGroups.gql";

import DashboardCardScaffold from "@/components/dashboard/cards/CardScaffoldGroups.vue";
import CardItemScaffold from "@/components/dashboard/cards/CardItemScaffoldGroups.vue";
import GroupModalWithButton from "@/components/teams/GroupModalWithButton.vue";
import GroupsIcon from "@/components/icons/GroupsIcon.vue";
import CircleWithInitials from "@/components/card/CircleWithInitials.vue";
import ColorIconContainer from "@/components/icons/ColorIconContainer.vue";
import CreateGroupConversationModal from "@/components/inbox/CreateGroupConversationModal.vue";
import GroupConversationProvider from "@/components/teams/GroupConversationProvider.vue";
import Roles from "@/entities/Roles";
import ConversationUserDataForModal from "@/entities/ConversationUserDataForModal";


import ChatIcon from "@/components/icons/ChatIcon.vue";
import GroupConversationUser from "@/entities/GroupConversationUser";
import RouteParams from "@/entities/RouteParams";




import RouteNames from "@/entities/RouteNames";
import CircleWithInitialsData from "@/entities/CircleWithInitialsData";
import { Team, Project_Activity, User, Team_Project, Project } from "@/generated/graphql";

interface groupParticipants {
  id: string;
  userId: string;
  name: string;
  role?: string;
  avatar: string;
}

interface groupContractors extends groupParticipants {
  deleted: boolean;
}

@Component({
  components: {
    DashboardCardScaffold,
    GroupModalWithButton,
    CardItemScaffold,
    GroupsIcon,
    CircleWithInitials,
    ColorIconContainer,
    CreateGroupConversationModal,
    GroupConversationProvider,
    ChatIcon,

  },
  apollo: {
    dashboardGroups: {
      query: GET_GROUPS,
      variables() {
        return {
          groupsFilter: this.filter.groups,
          activityFilter: this.filter.activities,
        };
      },
      update(data) {
        return data;
      },
    },
  },
})
export default class DashboardGroups extends Vue {
  @Prop({ type: String, required: true }) readonly companyId!: string;
  @Prop({ type: Object, required: true }) readonly currentUser!: User;
  // @Prop({ type: Array, default: () => [] }) readonly groupConversationUsers!: GroupConversationUser[];
  @Prop({ type: Array, default: () => [] }) readonly groupsTable!: Team[]
  @Prop({type: Array, default: () => []}) readonly contractors!: [];
  @Prop({type: Array, default: () => []}) readonly managers!: [];
  @Prop({type: Array, default: () => []}) readonly projects!: [];
  @Prop({type: Boolean, default: false}) readonly isAdmin!: boolean;


  created(): void { 
    this.teams()

  }
  clickedGroup: object = {}
  routes = RouteNames;
  dashboardGroups:any = null;
  newConversationDialog: boolean = false;
  checkboxOptions: GroupConversationUser[] = [];

  team!: any[]

  // @Watch("groupConversationUsers", {immediate: true})
  // onConversationUsersChange(users: GroupConversationUser[]): void {
  //   this.checkboxOptions = users
  //     .map((user) => ({
  //       ...user,
  //       selected: true,
  //   }));
  // }

  get filter(): object {
    return {
      groups: {
        archived: {
          _eq: false,
        },
      },
      activities: {
        completed: { _eq: false },
      },
    };
  }

  get groups(): Team[] {
    if (!this.dashboardGroups) {
      return [];
    }

    return this.dashboardGroups.groups;
  }

  teams(): Team[] {
    this.team = this.groupsTable
    return this.team


  }

  get activities(): Project_Activity[] {
    if (!this.dashboardGroups) {
      return [];
    }

    return this.dashboardGroups.activities;
  }

  get newGroups(): CircleWithInitialsData[] {
    return this.groups
      .map(({ id, name }: Team) => ({
        id,
        name: name || "",
      }))
      .splice(0, 5);
  }

  get newGroupsLength(): number {
    return this.groups.length;
  }

  get activityTotal(): any[] {
    if (!this.dashboardGroups) {
      return [];
    }

    return this.dashboardGroups.activityTotal;
  }

  get activitiesToRender(): Project_Activity[] {
    const uniqueIds = new Set();

    const uniqueActivities: Project_Activity[] = this.activities
      .reduce((arr: Project_Activity[], { project }: Project_Activity) => {
        const currentStepActivities: Project_Activity[] = [];

        project.project_activities.forEach((activity: Project_Activity) => {
          if (!uniqueIds.has(activity.id)) {
            currentStepActivities.push(activity);
            uniqueIds.add(activity.id);
          }
        });

        return [...arr, ...currentStepActivities];
      }, []);

    return uniqueActivities.splice(0, 5);
  }

  get inactiveGroupNumber(): number | undefined {
    if (!this.dashboardGroups) {
      return undefined;
    }

    return this.dashboardGroups.inactive.length;
  }

  get activitiesLength(): number {
    return this.activityTotal
      .map(({ project }: Team_Project) => {
        return project.project_activities_aggregate.aggregate?.count ?? 0;
      })
      .reduce((a: number, b :number) => a + b, 0);
  }

  get groupDetailsPageRoute(): RouteParams<{id: string}> {
    return {
      name: RouteNames.GROUP_DETAILS,
      params: {
        //@ts-ignore
        id: this.group.id
      },
    }
  }
  viewGroup(group: Team): void {
    this.$router.push({
      //@ts-ignore
      name: this.groupDetailsPageRoute,
      //@ts-ignore
      params: {id: group.id}
    });
  }



  // get routeParams(): RouteParams<{ id: string }> {
  //     return {
  //       name: RouteNames.GROUP_DETAILS,
  //       params: { id: this.groups.id },
  //     };
  //   }

  refetchGroups(): void {
    this.$apollo.queries.dashboardGroups.refetch();
  }

  groupMessage(group :Team): void {
      if(group){
        //@ts-ignore
        this.clickedGroup  = group;
      }
      this.newConversationDialog = true;
  }

  get groupManagers(): groupParticipants[]{
      if (!this.managers.length || !this.isAdmin) {
        return [];
      }
      return this.managers.map(({ manager }: any) => {
        return {
          id: manager.id,
          userId: manager.user.id,
          name: `${manager.user.given_name} ${manager.user.family_name}`,
          avatar: manager.user.avatar,
        };
      });
    }

    get groupContractors(): groupContractors[] {
      if (!this.contractors.length) {
        return [];
      }
      return this.contractors.map(({ contractor }: any) => {
        return {
          id: contractor.id,
          userId: contractor.user.id,
          name: `${contractor.user.given_name} ${contractor.user.family_name}`,
          role: Roles.CONTRACTOR,
          avatar: contractor.user.avatar,
          deleted: contractor.deleted,
        };
      });
    }

    get hasParticipants(): boolean {
      return this.conversationParticipants.length > 0;
    }

    get conversationParticipants(): ConversationUserDataForModal[] {
      const managers = this.groupManagers.map(manager => {
        return {
          ...manager,
          name: `${manager.name} (manager)`
        }
      })
      return [...this.groupContractors, ...managers];
    }
}
